import { Receipt } from "lucide-react";
import { NavigationLinkProps } from "../../providers/Router";
import { FEATURE_ROSTERS } from "../../utils/UserAccessControlUtils";
import RosterDirectoryPage from "./pages/RosterDirectoryPage";
import RosterIssuesPage from "./pages/RosterIssuesPage";
import FeatureFlags from "../../common/feature-flagging/FeatureFlags";

const RosterRouter: NavigationLinkProps[] = [
  {
    id: "7cdfe5a5-9f73-46c0-a0b4-c5c5f1e7b5d",
    title: "Rosters",
    description: "",
    path: "/rosters",
    auth: true,
    sidebar: true,
    secondarySidebar: false,
    icon: Receipt,
    component: RosterDirectoryPage,
    requiredFeature: FEATURE_ROSTERS,
    requiredPermissions: ["ANY"],
    requiredFeatureFlag: FeatureFlags.EMPLOYER_PORTAL_ROSTER_TIMESHEET_VIEW,
  },
  {
    id: "2fbce3f3-544c-4ab0-9ec2-75a8c6fb8c86",
    title: "Rosters",
    description: "",
    path: "/rosters/:id/errors",
    auth: true,
    sidebar: false,
    secondarySidebar: false,
    component: RosterIssuesPage,
    requiredFeature: FEATURE_ROSTERS,
    requiredPermissions: ["ANY"],
    requiredFeatureFlag: FeatureFlags.EMPLOYER_PORTAL_ROSTER_TIMESHEET_VIEW,
  },
];

export default RosterRouter;
